<template>
  <div ref="container">
    <a-modal :title="title" :width="600" :visible="visible" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 80%;">
      <a-table :dataSource="dataSource" :columns="columns">
        <template slot="action" slot-scope="text, record">
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record)">
            <a>删除</a>
          </a-popconfirm>
          <!-- <a @click="handleDelete(record)">删除</a> -->
        </template>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { fchApi } from '@/api/api'
export default {
  name: 'VendorModal',
  data() {
    return {
      title: '主营区域',
      visible: false,
      id: '',
      model: {},
      dataSource: [],

      columns: [
        {
          title: '主营区域',
          dataIndex: 'name',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  created() {},
  methods: {
    add(e) {
      console.log(e, 'e1')
      this.dataSource = []
      this.visible = true
      if (e.locationName) {
        this.dataSource = e.locationName.split(',').map((it) => {
          return { name: it }
        })
      }
      this.id = e.id
      console.log(this.dataSource, 'this.dataSource')
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    async handleOk() {
      // 触发表单验证
      // this.handleCancel()
      let list = this.dataSource.map((it) => {
        return it.name
      })
      console.log(list, 'list')
      console.log(list.toString(), 'this.dataSource')
      let params = {
        id: this.id,
        type: '经销商',
        locationName: list.toString(),
        isDeleteLocationName: '1',
      }
      console.log(params, 'params')

      const res = await fchApi(params)
      console.log(res, 'res')
      if (res.code == 200) {
        this.visible = false
        this.$emit('ok')
      } else {
        this.$message.error(res.data)
      }
    },
    handleDelete(e) {
      let idx = this.dataSource.indexOf(e)
      this.dataSource.splice(idx, 1)
      console.log(e, 'e')
    },

    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped>
.address {
  display: flex;
  flex-direction: column;
}
</style>